$('.js-toggle').on('click', (e) => {
  $(e.currentTarget).toggleClass('is_active')
  $(e.currentTarget).next().slideToggle(200)
})

$('.js-toggleButton').on('click', (e) => {
  const card = $(e.currentTarget).parents('.js-toggleWrapper')
  const text1 = $(e.currentTarget).data('text-1')
  const text2 = $(e.currentTarget).data('text-2')

  card.toggleClass('is_opened')

  if (card.hasClass('is_opened')) {
    $(e.currentTarget).find('span').text(text2)
  } else {
    $(e.currentTarget).find('span').text(text1)
  }
})

$('.js-toggleWrapper').each((index, item) => {
  const scroller = $(item).find('.dopcost-card__scroller')
  if (scroller.length > 0) {
    const height = scroller.height()
    const { scrollHeight } = scroller[0]
    const button = $(item).find('.js-toggleButton')

    if (scrollHeight > height) {
      button.removeAttr('style')
      scroller.removeClass('_no_scrolling')
    } else {
      button.hide()
      scroller.addClass('_no_scrolling')
    }
  }
})

